import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import NavLink from '../nav_link';
import ObjectMoverList from './maList--jobs-object-mover';
import MediaMoverList from './maList--jobs-media-mover';
import MediaExchangeList from './maList--jobs-media-exchange';
import JobTemplatesList from './maList--jobs-job-templates';

const styles = () => ({
    subheading: {
        paddingLeft: '32px',
        maxHeight: '40px',
        paddingRight: '1.0rem',
    },
    subheadingActive: {
        maxHeight: '40px',
        color: 'rgba(0, 0, 0, 0.95)',
        fontSize: '0.875rem',
        lineHeight: '1.46429em',
    },
    chevron: {
        fill: '#262626',
        marginRight: '-1rem',
    },
});

class MAListJobs extends React.Component {
    state = {
        openObjectMover: false,
        openMediaMover: false,
        openJobTemplates: false,
        openMediaExchange: false,
    };
    handleClickObjectMover = (event) => {
        let current = !this.state.openObjectMover;
        if (!event) {
            current = true;
        }
        this.setState({
            openObjectMover: current,
        });
    };
    handleClickMediaMover = (event) => {
        let current = !this.state.openMediaMover;
        if (!event) {
            current = true;
        }
        this.setState({
            openMediaMover: current,
        });
    };
    handleClickMediaExchange = (event) => {
        let current = !this.state.openMediaExchange;
        if (!event) {
            current = true;
        }
        this.setState({
            openMediaExchange: current,
        });
    };
    handleClickJobTemplates = (event) => {
        let current = !this.state.openJobTemplates;
        if (!event) {
            current = true;
        }
        this.setState({
            openJobTemplates: current,
        });
    };
    preventAction = (e) => {
        e.preventDefault();
    };

    render() {
        const { classes } = this.props;

        return (
            <React.Fragment>
                <Collapse component="li" in={this.props.isOpen} timeout="auto">
                    <List disablePadding>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/manager-agents/jobs/jobs-overview"
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Jobs Overview" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/manager-agents/jobs/job-management"
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Managing Jobs" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/manager-agents/jobs/job-details"
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Viewing Details" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/manager-agents/jobs/job-logs"
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Viewing Job Logs" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/manager-agents/jobs/job-views"
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Customizing Views" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/manager-agents/jobs/job-reports"
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Creating Reports" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/manager-agents/jobs/job-groups"
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Managing Groups" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/manager-agents/jobs/job-queuing"
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Queuing" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/manager-agents/jobs/job-labels"
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Labelling Jobs" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/manager-agents/jobs/maintenance"
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Understanding Maintenance" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            to="/manager-agents/jobs/database-maintenance"
                            onActive={this.props.onActive}
                        >
                            <ListItem button className={classes.subheading}>
                                <ListItemText secondary="Database Maintenance" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.preventAction}
                            to="/manager-agents/jobs/media-mover/"
                            onActive={this.props.onActive}
                        >
                            <ListItem button onClick={this.handleClickMediaMover} className={classes.subheading}>
                                <ListItemText secondary="Media Mover" />
                            </ListItem>
                        </NavLink>

                        <MediaMoverList
                            handleDrawerToggle={this.props.handleDrawerToggle}
                            onActive={() => {
                                this.handleClickMediaMover();
                                this.props.onActive();
                            }}
                        />

                        <NavLink
                            onClick={this.preventAction}
                            to="/manager-agents/jobs/object-mover/"
                            onActive={this.props.onActive}
                        >
                            <ListItem button onClick={this.handleClickObjectMover} className={classes.subheading}>
                                <ListItemText secondary="Object Mover" />
                            </ListItem>
                        </NavLink>

                        <ObjectMoverList
                            handleDrawerToggle={this.props.handleDrawerToggle}
                            onActive={() => {
                                this.handleClickObjectMover();
                                this.props.onActive();
                            }}
                        />

                        <NavLink
                            onClick={this.preventAction}
                            to="/manager-agents/jobs/job-templates/"
                            onActive={this.props.onActive}
                        >
                            <ListItem button onClick={this.handleClickJobTemplates} className={classes.subheading}>
                                <ListItemText secondary="Job Templates" />
                            </ListItem>
                        </NavLink>

                        <JobTemplatesList
                            handleDrawerToggle={this.props.handleDrawerToggle}
                            onActive={() => {
                                this.handleClickJobTemplates();
                                this.props.onActive();
                            }}
                        />

                        <NavLink
                            onClick={this.preventAction}
                            to="manager-agents/jobs/media-exchange/"
                            onActive={this.props.onActive}
                        >
                            <ListItem button onClick={this.handleClickMediaExchange} className={classes.subheading}>
                                <ListItemText secondary="Media Exchange" />
                            </ListItem>
                        </NavLink>

                        <MediaExchangeList
                            handleDrawerToggle={this.props.handleDrawerToggle}
                            onActive={() => {
                                this.handleClickMediaExchange();
                                this.props.onActive();
                            }}
                        />
                    </List>
                </Collapse>
            </React.Fragment>
        );
    }
}

MAListJobs.propTypes = {
    classes: PropTypes.object.isRequired,
    isOpen: PropTypes.object,
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default withStyles(styles)(MAListJobs);
